// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1_jfV","row":"styles_row__h15_7"};